module.exports = __webpack_public_path__ + "img/anita-pisti.5761c2ef.jpg";